// src/pages/AcoesSociais.tsx  (ou substitua SecaoAcoesSociais.tsx)
import React, { useEffect, useState } from 'react';
import { Heart } from 'lucide-react';
import { API_BASE } from '../utils/apiConfig';

// ... (importe os types e o SecaoAcoesSociais do components)
import SecaoAcoesSociais from './SecaoAcoesSociais';

const AcoesSociais: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero */}
      <div className="py-16 text-center"
        style={{ background: 'linear-gradient(135deg, #0a0e27 0%, #1a1f3a 100%)' }}>
        <p className="text-emerald-400 text-sm font-bold uppercase tracking-widest mb-3">
          Federação dos Profissionais da Beleza
        </p>
        <h1 className="text-4xl md:text-5xl font-black text-white mb-4">
          Ações Sociais
        </h1>
        <p className="text-gray-400 max-w-xl mx-auto text-lg">
          Iniciativas que transformam comunidades e fortalecem nossa categoria.
        </p>
      </div>

      {/* Conteúdo — mostra mensagem se vazio */}
      <AcoesSociaisConteudo />
    </div>
  );
};

// Componente interno que lida com vazio
const AcoesSociaisConteudo: React.FC = () => {
  const [actions, setActions] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE}/social-actions/published?limit=12`)
      .then(r => r.ok ? r.json() : { actions: [] })
      .then(d => setActions(d.actions ?? []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div className="flex items-center justify-center py-32">
      <div className="w-10 h-10 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin" />
    </div>
  );

  if (actions.length === 0) return (
    <div className="flex flex-col items-center justify-center py-32 px-4 text-center">
      <div className="w-20 h-20 rounded-full bg-emerald-50 flex items-center justify-center mb-6">
        <Heart className="w-10 h-10 text-emerald-300" />
      </div>
      <h2 className="text-2xl font-black text-gray-700 mb-3">Em breve</h2>
      <p className="text-gray-400 max-w-md">
        Estamos preparando nossas próximas ações sociais. Volte em breve para acompanhar nossas iniciativas.
      </p>
    </div>
  );

  // Quando tiver conteúdo, reutiliza o componente da Home
  return <SecaoAcoesSociais />;
};

export default AcoesSociais;